export const subscriptionKeys = {
  all: ['subscription'] as const,
  current: () => [...subscriptionKeys.all, 'current'] as const,
  plans: () => [...subscriptionKeys.all, 'plans'] as const,
  feature: (feature: string) => [...subscriptionKeys.all, 'feature', feature] as const,
} as const;
